import { NavLink, Outlet } from "react-router-dom";
import { FiFolder, FiZap } from "react-icons/fi";
import { useComponentTranslation } from "@/services/i18n";

const translations = {
  en: {
    files: "Files",
    onboard: "Onboard",
  },
  fr: {
    files: "Fichiers",
    onboard: "Onboard",
  },
};

export default function BrainLayout() {
  const { t } = useComponentTranslation(translations);

  const linkClass = ({ isActive }) =>
    `flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors -mb-px ${
      isActive
        ? "border-primary text-primary"
        : "border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300"
    }`;

  return (
    <div className="min-h-[calc(100vh-64px)] bg-gray-50 flex flex-col">
      <div className="bg-white border-b border-gray-200 px-8">
        <nav className="flex gap-2">
          <NavLink to="/recruiter/brain/files" className={linkClass}>
            <FiFolder className="w-4 h-4" />
            <span>{t("files")}</span>
          </NavLink>
          <NavLink to="/recruiter/brain/onboard" className={linkClass}>
            <FiZap className="w-4 h-4" />
            <span>{t("onboard")}</span>
          </NavLink>
        </nav>
      </div>

      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
